/**
 * @generated SignedSource<<9d1c2b5386ce980964e6ef87d260324a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type integrations_Settings_Fragment$data = {
  readonly chatbotAgentId: string | null | undefined;
  readonly chatbotTitle: string | null | undefined;
  readonly leadfeederTracker: string | null | undefined;
  readonly salesforceMid: string | null | undefined;
  readonly zoomInfoTracker: string | null | undefined;
  readonly " $fragmentType": "integrations_Settings_Fragment";
};
export type integrations_Settings_Fragment$key = {
  readonly " $data"?: integrations_Settings_Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"integrations_Settings_Fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "integrations_Settings_Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "salesforceMid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "leadfeederTracker",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "zoomInfoTracker",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chatbotAgentId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chatbotTitle",
      "storageKey": null
    }
  ],
  "type": "ZnglyInfo_Znglyinfo",
  "abstractKey": null
};

(node as any).hash = "3070bebe0a3dbb62ee1cf06c34554d63";

export default node;
